import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { msg } from "../../constants"
import RegisterTextField from "./RegisterTextField"
import RegisterSelectField from "./RegisterSelectField"
import RegisterDateField from "./RegisterDateField"
import RegisterFooter from "./RegisterFooter"
import {
    fetchProvinces,
    fetchDistricts,
    fetchSubDistricts,
    fetchZipCodes
} from "../../store/register/addressAction";
const locale = require("react-redux-i18n").I18n;
class RegisterForm extends Component {

    state = {
        firsttime: true,
        provinceId: 0,
        provinceName: 0,
        provinceKey: 0,
        districtId: 0,
        districtName: 0,
        districtKey: 0,
        districtHtml: '',
        subDistrictId: 0,
        subDistrictName: 0,
        subDistrictKey: 0,
    };

    async componentWillMount() {
        this.props.openModel();
        await this.props.fetchProvinces();
        await this.props.fetchDistricts();
        await this.props.fetchSubDistricts();
        await this.props.fetchZipCodes();
        this.props.closeModal();
    }

    componentDidMount() {
        window.initialDatepicker();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialValues && nextProps.provinces.length > 0) {
            if (this.state.firsttime && nextProps.initialValues.address) {
                const { city, amphur, tumbon } = nextProps.initialValues.address;
                if (city && amphur && tumbon) {
                    this.getProvinceId(nextProps.provinces, city)
                    this.getDistrictId(nextProps.districts, amphur)
                    this.getSubDistrictId(nextProps.subDistricts, tumbon)
                }
            }
        }
        if (this.state.provinceId && this.state.districtId && this.state.subDistrictId) {
            this.setState({
                firsttime: false
            })
        }
    }

    getTitleVal = (word) => {
        const title = this.props.titles.find(title => {
            return title.title_th === word
        });
        return title ? title.title : word;
    };

    getProvinceId = (provinces, city) => {
        const index = provinces.findIndex(province => province.name === city);
        if (index > -1) {
            this.setState({
                provinceId: index,
                provinceKey: provinces[index].id,
                provinceName: provinces[index].name,
            })
        }
    };

    getDistrictId = (districts, amphur) => {
        const index = districts.findIndex(district => district.name === amphur && district.provinceID === this.state.provinceKey);
        if (index > -1) {
            this.setState({
                districtId: index,
                districtKey: districts[index].id,
                districtName: districts[index].name
            });
        }
    };

    getSubDistrictId = (subDistricts, tumbon) => {
        const index = subDistricts.findIndex(subDistrict => subDistrict.name === tumbon && subDistrict.districtID === this.state.districtKey);
        if (index > -1) {
            this.setState({
                subDistrictId: index,
                subDistrictKey: subDistricts[index].id,
                subDistrictName: subDistricts[index].name
            });
        }
    };

    getDistrict = () => {
        return this.props.districts.filter(district =>
            district.provinceID === this.state.provinceKey
        )
    };

    getSubDistrict = () => {
        return this.props.subDistricts.filter(subDistrict =>
            subDistrict.provinceID === this.state.provinceKey && subDistrict.districtID === this.state.districtKey
        )
    };

    getZipcode = () => {
        return this.props.zipcodes.filter(zipcode =>
            zipcode.provinceID === this.state.provinceKey && zipcode.districtID === this.state.districtKey && zipcode.subDistrictID === this.state.subDistrictKey
        )
    };

    onIdCardExpireChange = ({ target }) => {
        this.props.change("id_card_expire", target.value);
    };

    onBirthDateChange = ({ target }) => {
        this.props.change("birthdate", target.value);
    };

    onJobChange = ({ target }) => {
        const selectedIndex = target.options.selectedIndex;
        const id = target.options[selectedIndex].getAttribute('id');
        this.props.change("job_code", id);
    };

    onProvinceChange = ({ target }) => {
        const selectedIndex = target.options.selectedIndex;
        const id = target.options[selectedIndex].getAttribute('id');
        const value = target.options[selectedIndex].getAttribute('value');;
        const province = this.props.provinces.find(province => province.name === value);
        this.setState({
            provinceId: id,
            provinceKey: province.id,
            provinceName: value,
            districtId: 0,
            subDistrictId: 0,
        });
        this.props.change("address.amphur", "");
        this.props.change("address.tumbon", "");
        this.props.change("address.zip", "");
    };

    onDistrictChange = ({ target }) => {
        const selectedIndex = target.options.selectedIndex;
        const id = target.options[selectedIndex].getAttribute('id');
        const value = target.options[selectedIndex].getAttribute('value');
        const district = this.props.districts.find(district => district.name === value && district.provinceID === this.state.provinceKey);
        this.setState({
            districtId: id,
            districtKey: district.id,
            districtName: value,
            subDistrictId: 0
        });
        this.props.change("address.tumbon", "");
        this.props.change("address.zip", "");
    }

    onSubDistrictChange = ({ target }) => {
        const selectedIndex = target.options.selectedIndex;
        const id = target.options[selectedIndex].getAttribute('id');
        const value = target.options[selectedIndex].getAttribute('value');
        const subDistrict = this.props.subDistricts.find(
            subDistrict => subDistrict.name === value
                && subDistrict.provinceID === this.state.provinceKey
                && subDistrict.districtID === this.state.districtKey)
        this.setState({
            subDistrictId: id,
            subDistrictKey: subDistrict.id,
            subDistrictName: value
        });
        this.props.change("address.zip", "");
    }

    render() {

        if (this.props.initialValues && this.props.initialValues.title) {
            this.props.initialValues.title = this.getTitleVal(this.props.initialValues.title)
        }

        const address_company = this.props.address_company.map((project) =>
            <option key={project.id} id={project.id} value={project.address_id}>{project.address_name}</option>
        );
        address_company.unshift(
            <option key="t" value="0">-- {locale.t("formSelAddress_company")} --</option>
        );
        const address_delivery = this.props.address_delivery.map((project) =>
            <option key={project.id} id={project.id} value={project.address_id}>{project.address_name}</option>
        );
        address_delivery.unshift(
            <option key="t" value="0">-- {locale.t("formSelAddress_delivery")} --</option>
        );
        const titleItems = this.props.titles.map((title) =>
            <option key={title.title} id={title.title} value={title.title}>{title.title_th}</option>
        );
        titleItems.unshift(
            <option key="t" value="0">-- {locale.t("formSelTitle")} --</option>
        );

        const provinceItems = this.props.provinces.map((province, index) =>
            <option key={province.id} id={index} value={province.name}>{province.name}</option>
        );
        provinceItems.unshift(
            <option key="p" value="0">-- {locale.t("formSelProvince")} --</option>
        );

        const districtItems = this.getDistrict().map((district, index) =>
            <option key={index} id={index} value={district.name}>{district.name}</option>
        );
        districtItems.unshift(
            <option key="d" value="0">-- {locale.t("formSelAmpur")} --</option>
        );

        const subDistrictItems = this.getSubDistrict().map((subDistrict, index) =>
            <option key={index} id={index} value={subDistrict.name}>{subDistrict.name}</option>
        );
        subDistrictItems.unshift(
            <option key="s" value="0">-- {locale.t("formSelTumbon")} --</option>
        );

        const zipcodeItems = this.getZipcode().map((zipcode, index) =>
            <option key={index} id={index} value={zipcode.code}>{zipcode.code}</option>
        );
        zipcodeItems.unshift(
            <option key="z" value="0">-- {locale.t("formSelZip")} --</option>
        );

        const listJob = this.props.initialValues ? this.props.initialValues.listJob : undefined

        const listJobItems = listJob ?
            this.props.initialValues.listJob.map((job) =>
                <option key={job.job_code} id={job.job_code} value={job.job_name}>{job.job_name}</option>
            )
            : '';
        if (listJobItems !== '') {
            listJobItems.unshift(
                <option key="p" value="0">-- {locale.t("formPosition")} --</option>
            )
        }

        const { onCustomerSubmit, handleSubmit, submitting, invalid } = this.props;
        return (
            <div className="box-order-main-b">
                <form onSubmit={handleSubmit(onCustomerSubmit)}>
                    <div className="box-register_form">
                        <div className="row">
                            <div className="col-sm-6 col-xs-12">
                                <Field name="tel" type="text" component={RegisterTextField} label={locale.t("formTel")} star={"*"} validate={[required, idPhone]} disabled={this.props.disabled} maxLength="10" />
                                <Field name="email" type="email" component={RegisterTextField} label={locale.t("formEmail")} disabled={this.props.disabled} />
                                {listJob ?
                                    <>
                                        <div className={'hide'}>
                                            <Field name="job_code"
                                                component={RegisterTextField}
                                                validate={[required]}
                                                disabled={this.props.disabled} />
                                        </div>
                                        <Field name="job"
                                            component={RegisterSelectField}
                                            label={locale.t("formPosition")}
                                            star={"*"} options={listJobItems}
                                            onChange={this.onJobChange}
                                            validate={[required]}
                                            disabled={this.props.disabled} />
                                    </>
                                    :
                                    <>
                                        <Field name="job" type="text"
                                            component={RegisterTextField}
                                            label={locale.t("formPosition")}
                                            star={"*"} validate={[required]}
                                            disabled={this.props.disabled} />
                                    </>
                                }
                                {this.props.address_company &&
                                    <Field name="department" component={RegisterSelectField} label={locale.t("formCompany")} star={"*"} options={address_company} validate={[required]} disabled={this.props.disabled} />
                                }
                                {this.props.address_delivery &&
                                    <Field name="address_delivery" component={RegisterSelectField} label={locale.t("formAddress_delivery")} star={"*"} options={address_delivery} validate={[required]} disabled={this.props.disabled} />
                                }
                                <Field name="title" component={RegisterSelectField} label={locale.t("formTitle")} star={"*"} options={titleItems} validate={[required]} disabled={this.props.disabled} />
                                <Field name="firstname" type="text" component={RegisterTextField} label={locale.t("formFName")} star={"*"} validate={[required]} disabled={this.props.disabled} />
                                <Field name="lastname" type="text" component={RegisterTextField} label={locale.t("formLName")} star={"*"} validate={[required]} disabled={this.props.disabled} />
                                <Field name="id_card" type="text" component={RegisterTextField} label={locale.t("formIDCard")} star={"*"} validate={[required, idCard]} disabled={this.props.disabled} maxLength="13" />
                                <Field name="id_card_expire" type="text" component={RegisterDateField} label={locale.t("formexpireIDCard")} star={"*"} id="datepicker1" onChange={this.onIdCardExpireChange} validate={[required]} disabled={this.props.disabled} />
                                <Field name="birthdate" type="text" component={RegisterDateField} label={locale.t("formDOB")} star={"*"} id="datepicker2" onChange={this.onBirthDateChange} validate={[required]} disabled={this.props.disabled} />
                            </div>
                            <div className="col-sm-6 col-xs-12">
                                <Field name="address.houseno" type="text" component={RegisterTextField} label={locale.t("formAddrIDCard")} star={"*"} validate={[required]} disabled={this.props.disabled} maxLength="10" />
                                <Field name="address.building_name" type="text" component={RegisterTextField} label={locale.t("formBuilding")} disabled={this.props.disabled} />
                                <Field name="address.floors" type="text" component={RegisterTextField} label={locale.t("formFloors")} disabled={this.props.disabled} maxLength="10" />
                                <Field name="address.moo" type="text" component={RegisterTextField} label={locale.t("formMoo")} disabled={this.props.disabled} maxLength="10" />
                                <Field name="address.soi" type="text" component={RegisterTextField} label={locale.t("formSoi")} disabled={this.props.disabled} />
                                <Field name="address.streetname" type="text" component={RegisterTextField} label={locale.t("formStreet")} disabled={this.props.disabled} />
                                <Field name="address.city" component={RegisterSelectField} label={locale.t("formProvince")} star={"*"} options={provinceItems} onChange={this.onProvinceChange} validate={[required, zero]} disabled={this.props.disabled} />
                                <Field name="address.amphur" component={RegisterSelectField} label={locale.t("formAmpur")} star={"*"} options={districtItems} onChange={this.onDistrictChange} validate={[required, zero]} disabled={this.props.disabled} />
                                <Field name="address.tumbon" component={RegisterSelectField} label={locale.t("formTumbon")} star={"*"} options={subDistrictItems} onChange={this.onSubDistrictChange} validate={[required, zero]} disabled={this.props.disabled} />
                                <Field name="address.zip" component={RegisterSelectField} label={locale.t("formZip")} star={"*"} options={zipcodeItems} validate={[required, zero]} disabled={this.props.disabled} defalutValue={this.state.zip} />
                                <Field name="trueid_recommender" type="text" component={RegisterTextField} label={locale.t("trueIdrec")} disabled={this.props.disabled} />
                            </div>
                        </div>
                    </div>
                    <RegisterFooter mode={this.props.mode} disabled={invalid || submitting} />
                </form>
            </div>
        );
    }
}

const required = value => value ? undefined : msg.custRequireFiled;
const zero = value => value !== "0" ? undefined : msg.custRequireFiled;
const idPhone = value => value && /^[0-9]{10}$/.test(value) ? undefined : "กรุณาใส่หมายเลขให้ถูกต้อง";
const idCard = value => value && /^[0-9]{13}$/.test(value) ? undefined : msg.custInvalidIdCard;

const handleSubmitSuccess = (result, dispatch, props) => {
    let message = msg.errMessage;
    let success = false;
    if (result.payload) {
        success = result.payload.customer_id ? true : false;
        if (success) {
            message = msg.custSuccessUpdate;
        }
    }
    props.onShowSubmitModal(message, success);
}

const handleSubmitFail = (errors, dispatch, props) => {
    console.log(errors);
    props.onShowSubmitModal(msg.errMessage);
}

// const mapStateToProps = ({ customer }) => {
//     return ({
//         initialValues: customer.data
//         
//     })
// };

const mapStateToProps = state => ({
    initialValues: state.customer.data,
    titles: state.titles.items,
    address_delivery: state.titles.delivery,
    address_company: state.titles.company,
    provinces: state.address.provinces,
    districts: state.address.districts,
    subDistricts: state.address.subDistricts,
    zipcodes: state.address.zipCodes,
    l: state.i18n.locale
});

RegisterForm = reduxForm({
    form: "register",
    enableReinitialize: true,
    onSubmitSuccess: handleSubmitSuccess,
    onSubmitFail: handleSubmitFail
})(RegisterForm);

export default connect(
    mapStateToProps, {
    fetchProvinces,
    fetchDistricts,
    fetchSubDistricts,
    fetchZipCodes,
})(RegisterForm);

